import { PageConfig } from "@/types/types";
import { componentMap } from "../../components/componentMap";
import { PageProps } from "@/getServerSideProps/getServerSideProps";

type SlotProps = {
  id?: string;
  name: string;
  pageConfig: PageConfig;
  className?: string;
  sizes: string;
} & PageProps;

export function Slot({
  id,
  name,
  className = "",
  sizes,
  pageConfig,
  ...standardProps
}: SlotProps) {
  const components = pageConfig.slots[name];

  if (!components || components.length < 1) {
    return null;
  }

  return (
    <div id={id} className={className} data-slot={name} data-testid="slot">
      {components?.map((componentConfig, index) => {
        const Component = componentMap[componentConfig.name];
        const componentKey = `${componentConfig.name}-${index}`;

        return Component ? (
          <Component
            key={componentKey}
            {...standardProps}
            configProps={componentConfig.props}
            sizes={sizes}
          />
        ) : null;
      })}
    </div>
  );
}
